
import { DEV_MODE } from "./devMode";
import { Events } from "./dataSources/events";
import { ChroniclerPage, DivisionID, PlayerID, TeamID } from "./models/common";
import { ChroniclerItem, ChroniclerData, ChroniclerRawResult, ChroniclerTeamBlessingPreferences, ElectionModel, ForbiddenBook, GameEvent, GameModel, PlayerModel, SimModel, TeamModel, ChroniclerWrappedData, ElectionEvent } from "./models/models";
import { ISnapshotResults, Snapshot, SnapshotsToLoad } from "./dataSources/snapshots";
import cachedData from "./tempData";
import { IAllGames } from "./dataProcessors";

/*
const oldCorsProxies = [
    'https://cors-proxy.blaseball-reference.com',
    'https://corsmechanics.brella.dev/www.blaseball.com',
    'https://api.sibr.dev/corsmechanics/www.blaseball.com'];
//*/

//const urlBase = `https://api2.blaseball.com/`;

const showURLCalls = DEV_MODE && false;

//let hasShownError = false;

async function doFetch(url: string) {
    if (showURLCalls) {
        console.log(`Wrapping fetch call to <${url}>`)
    }

    // Eventually, this can be a system to actually cache data in local storage
    if (cachedData[url]) {
        console.log(`fetched ${url} from cache:`)
        console.log(cachedData[url])
        return Promise.resolve(cachedData[url])
    } else {
        //console.log(`Need to manually fetch <${url}>`)
        return (await (fetch(url))).json()
    }

    //return await (fetch(url))

}

/*
async function databaseQuery(endpoint: string, queryParams?: Record<string, string>) {
    const url = urlBase + endpoint + queryString(queryParams);
    try {

        var response = await doFetch(url);
        return await response//.json(); // TODO remove me when you un-wrap the fetch
    } catch (error) {
        if (!hasShownError) {
            hasShownError = true;
            window.alert("Error fetching data")
        }
        return {};
    }
}
//*/

function queryString(queryParams?: Record<string, string>) {
    let result = "";
    for (let key in queryParams) {
        result += "&" + key + "=" + queryParams[key];
    }
    if (result.length > 0) {
        result = "?" + result.slice(1);
    }
    return result;
}
/*
type SIBREndpoints = "games" | "teams" | "players"

type SIBRError = {
    message: "Service Unavailable" | "Internal Server Error"
}
async function rawSibrQuery<T>(endpoint: SIBREndpoints): Promise<T | SIBRError> {
    switch (endpoint) {
        case "games": return doFetch("https://api2.sibr.dev/mirror/games")
        case "teams": return doFetch("https://api2.sibr.dev/mirror/teams")
        case "players": return doFetch("https://api2.sibr.dev/mirror/players")
    }

}

function isSIBRError(value: SIBRError | any): value is SIBRError {
    return (value) && ((value.message === "Service Unavailable") || (value.message === "Internal Server Error"))
}
/*
async function sibrQuery<T>(endPoint: SIBREndpoints): Promise<T[]> {
    const value = await rawSibrQuery<T[]>(endPoint)
    if (isSIBRError(value)) {
        console.warn(`Error fetching ${endPoint} from SIBR Mirror`)
        return []
    }
    return value;
}

//*/

// Chronicler
type ChroniclerField = "kind" | "at" | "search" | "order";
const MAX_PAGES_TO_LOAD = 30;

type ChroniclerStandardEndpoint = "entities" | "versions";
type ChroniclerRawDataEndpoint = "game-events"

async function chroniclerQuery<T>(endPoint: ChroniclerStandardEndpoint, queryInfo: Partial<Record<ChroniclerField, string>>): Promise<ChroniclerWrappedData<T>> {

    return rawChroniclerQuery<ChroniclerItem<T>>(endPoint, queryInfo);

}

async function chroniclerSpecialQuery<T>(endPoint: ChroniclerRawDataEndpoint, queryInfo: Partial<Record<ChroniclerField, string>>): Promise<ChroniclerData<T>> {

    return rawChroniclerQuery<T>(endPoint, queryInfo);

}


type ChroniclerEndpoint = ChroniclerStandardEndpoint | ChroniclerRawDataEndpoint;
async function rawChroniclerQuery<T>(endPoint: ChroniclerEndpoint, queryInfo: Partial<Record<ChroniclerField, string>>): Promise<ChroniclerData<T>> {

    let allItems: T[] = [];
    let next: ChroniclerRawResult<T>;
    let page: ChroniclerPage | null = null;
    let pagesLoaded = 0;

    let pageThresholdForEndpoint = 3000; // TODO calculate this

    if (endPoint === "versions") {
        pageThresholdForEndpoint = 1000;
    }


    do {
        pagesLoaded++;

        let queryToUse: Record<ChroniclerField | string, string> = queryInfo;
        if (page) {
            queryToUse = { ...queryInfo, page }
        }
        const url = `https://api2.sibr.dev/chronicler/v0/${endPoint}${queryString(queryToUse)}`
        if (showURLCalls) {
            console.log(`Wrapping fetch call to <${url}>`)
        }
        next = await doFetch(url)

        if (pagesLoaded > 1 && showURLCalls) {
            console.log(`Requesting page ${pagesLoaded} for ${endPoint}. ${allItems.length} items so far, ${next.items.length} from this page`)
        }
        allItems = allItems.concat(next.items);
        page = next.next_page;
    } while (next.items.length >= pageThresholdForEndpoint && next.next_page !== null && pagesLoaded < MAX_PAGES_TO_LOAD);

    if (pagesLoaded >= MAX_PAGES_TO_LOAD) {
        console.warn(`Chronicler ${endPoint}${queryString(queryInfo)} request exceeded page cap`)
    }


    return {
        items: allItems
    }
}

// -------------------------------------------------------------------------------- //


async function simulationData(): Promise<SimModel> {
    let foo = await chroniclerQuery<SimModel>("entities", {
        kind: "sim"
    })
    return foo.items[0]?.data;
}

async function book(): Promise<ForbiddenBook> {
    return doFetch("https://blaseball-texts.s3.us-west-2.amazonaws.com/forbiddenbook.json")
}

/*
async function team(teamId: TeamID, seasonId: SeasonID, day = 0): Promise<TeamModel> {
    return databaseQuery(`seasons/${seasonId}/days/${day}/teams/${teamId}`)
}

async function teams(seasonId: SeasonID, day = 0): Promise<teamsModel> {
    return databaseQuery(`/seasons/${seasonId}/days/${day}/teams/`)
}//*/

/*
async function player(playerId: PlayerID, seasonId: SeasonID, day = 0): Promise<playerModel> {
    return databaseQuery(`seasons/${seasonId}/days/${day}/players/${playerId}`)
}//*/

// SIBR mirrors
/*
async function teams(): Promise<TeamModel[]> {
    return sibrQuery("teams")
}

async function games(): Promise<GameModel[]> {
    return sibrQuery("games")
}

async function players(): Promise<PlayerModel[]> {
    return sibrQuery("players")
}
//*/


async function teams(): Promise<TeamModel[]> {
    const now = (new Date(Date.now())).toISOString();
    const simData = await chroniclerQuery<SimModel>("entities", { kind: "sim", at: now })
    const divisonIds: DivisionID[] = [];
    simData.items.forEach(sim => {
        sim.data.simData.currentLeagueData.subLeagues.forEach((subLeague => {
            subLeague.divisions.forEach(division => {
                divisonIds.push(division.id)
            })
        }))
    })

    const teamsData = await chroniclerQuery<TeamModel>("entities", {
        kind: "team",

    })
    const allTeams = teamsData.items.map(item => item.data)

    return allTeams.filter(team => divisonIds.includes(team.division?.id))
}
async function games(): Promise<GameModel[]> {
    const gamesData = await chroniclerQuery<GameModel>("entities", {
        kind: "game",

    })
    return gamesData.items.map(item => item.data)
}


async function players(): Promise<PlayerModel[]> {
    const playersData = await chroniclerQuery<PlayerModel>("entities", {
        kind: "player",

    })
    return playersData.items.map(item => item.data)
}

// Chronicler

async function snapshotSim(snapshot: Snapshot): Promise<ChroniclerWrappedData<SimModel>> {
    return chroniclerQuery<SimModel>("entities", {
        kind: "sim",
        at: snapshot.date
    })
}

async function snapshotPlayers(snapshot: Snapshot): Promise<ChroniclerWrappedData<PlayerModel>> {
    return chroniclerQuery<PlayerModel>("entities", {
        kind: "player",
        at: snapshot.date
    })
}

async function snapshotTeams(snapshot: Snapshot): Promise<ChroniclerWrappedData<TeamModel>> {
    return chroniclerQuery<TeamModel>("entities", {
        kind: "team",
        at: snapshot.date
    })
}

async function snapshotGames(): Promise<ChroniclerWrappedData<GameModel>> {
    return chroniclerQuery<GameModel>("entities", {
        kind: "game"
    });
}


async function snapshot(snapshot: Snapshot): Promise<ISnapshotResults> {
    const simResult = await snapshotSim(snapshot);
    const teamsResult = await snapshotTeams(snapshot);
    const playersResult = await snapshotPlayers(snapshot);
    return { snapshot, simResult, teamsResult, playersResult }
}

async function snapshots(): Promise<ISnapshotResults[]> {
    const results = [];
    for (var i = 0; i < SnapshotsToLoad.length; i++) {
        const result = await snapshot(SnapshotsToLoad[i])
        results.push(result)
    }

    const allGames = await snapshotGames();
    results.forEach(result => {
        if (result.simResult.items.length !== 1) {
            console.warn(`Error mapping simdata for snapshot ${result.snapshot.name} [${result.snapshot.date}]`)
        } else {
            const seasonId = result.simResult.items[0].data.simData.currentSeasonId;
            const filteredGames = allGames.items.filter(item => item.data.seasonId === seasonId)
            result.gamesResult = {
                items: filteredGames
            }
        }
    })

    return results;
}

// Election data from chron
async function electionInfo() {
    const now = (new Date(Date.now())).toISOString();
    const simData = await chroniclerQuery<SimModel>("entities", { kind: "sim", at: now })
    if (simData.items.length !== 1) {
        console.warn("Error getting sim for election data")
    }
    const seasonId = simData.items[0].data.simData.currentSeasonId;

    const electionsData = await chroniclerQuery<ElectionModel>("entities", { kind: "season_elections", at: now })
    const thisSeasonElectionsData = electionsData.items.filter(item => item.data.decrees[0].seasonId === seasonId);
    if (thisSeasonElectionsData.length !== 1) {
        console.warn("Error getting election options for this season")
    }

    const preferenceData = await chroniclerQuery<ChroniclerTeamBlessingPreferences>("entities", { kind: "team_blessing_preferences", at: now })

    return {
        elections: thisSeasonElectionsData[0].data,
        preferences: preferenceData.items.map(item => item.data)
    }

}

async function gameEvents() {
    let allItems: GameEvent[] = [];
    for (let i = 0; i < Events.searches.length; i++) {
        const searchTerm = Events.searches[i];
        const newData = await chroniclerSpecialQuery<GameEvent>("game-events", { search: searchTerm })

        allItems = allItems.concat(newData.items)
    }

    // Fix apostrophe in Hawai'i Fridays
    allItems.forEach(item => {
        item.data.displayText = item.data.displayText.replace("&#x27;", "'")
    })

    return allItems;
}

async function electionEvents(): Promise<ElectionEvent[]> {
    const electionsData = await chroniclerQuery<ElectionModel>("entities", { kind: "season_elections" })

    let allItems: ElectionEvent[] = []

    electionsData.items.forEach(item => {
        item.data.blessings.forEach(group => {
            if (group.electionComplete) {
                group.electionOptions.forEach(option => {
                    option.results.forEach(result => {
                        allItems.push({
                            name: option.name,
                            seasonId: group.seasonId,
                            timestamp: new Date(group.endTimestamp).toISOString(),
                            outcomeStrings: result.outcomeStrings,
                            winningTeam: result.resultType === "blessing" ? result.winningTeam : undefined
                        })
                    })
                })
            }
        })

        item.data.decrees.forEach(group => {
            if (group.electionComplete) {
                group.electionOptions.forEach(option => {
                    option.results.forEach(result => {
                        allItems.push({
                            name: option.name,
                            seasonId: group.seasonId,
                            timestamp: new Date(group.endTimestamp).toISOString(),
                            outcomeStrings: result.outcomeStrings,
                        })
                    })
                })
            }
        })

    })

    return allItems
}

interface eventWithContextBase {
    _type: "GameEvent" | "ElectionEvent"
    event: GameEvent | ElectionEvent,
    teamsBefore: TeamModel[],
    teamsAfter: TeamModel[],
    playersBefore: PlayerModel[],
    playersAfter: PlayerModel[]
}

interface gameEventWithContext extends eventWithContextBase {
    _type: "GameEvent",
    event: GameEvent
}

interface electionEventWithContext extends eventWithContextBase {
    _type: "ElectionEvent",
    event: ElectionEvent
}

export type EventWithContext = gameEventWithContext | electionEventWithContext

let isLoadingTeamData = false;
async function teamDataForEvents(gameEvents: GameEvent[], electionEvents: ElectionEvent[], allGames: IAllGames, allTeams: TeamModel[], allPlayers: PlayerModel[]) {

    if (isLoadingTeamData) {
        console.warn("Skipping attempt to re-load event context data")
        return [];
    }
    if (DEV_MODE) {
        console.log("Starting to process event context")
    }
    isLoadingTeamData = true;

    const data: EventWithContext[] = [];

    const allTeamVersions = await chroniclerQuery<TeamModel>("versions", {
        kind: "team"
    })
    const allPlayerVersions = await chroniclerQuery<PlayerModel>("versions", {
        kind: "player"
    })

    const playerVersionsById: Record<PlayerID, ChroniclerItem<PlayerModel>[]> = {}
    allPlayerVersions.items.forEach(item => {
        const id = item.data.id
        if (!playerVersionsById[id]) {
            playerVersionsById[id] = []
        }
        playerVersionsById[id].push(item);

    })


    const teamVersionsById: Record<TeamID, ChroniclerItem<TeamModel>[]> = {}
    allTeamVersions.items.forEach(item => {
        if (teamVersionsById[item.data.id] === undefined) {
            teamVersionsById[item.data.id] = []
        }
        teamVersionsById[item.data.id].push(item)
    })

    for (let event of gameEvents) {

        const result = Events.gameEventContext(event, allGames, teamVersionsById, playerVersionsById)
        if (result) {
            data.push(result)
        }
    }
    const allPlayerNames = allPlayers.map(player => player.name);
    const playerIdByName: Record<string, PlayerID> = {};
    allPlayers.forEach(player => {
        playerIdByName[player.name] = player.id
    })

    for (let event of electionEvents) {

        const result = Events.electionEventContext(event, allTeams, teamVersionsById, allPlayerNames, playerIdByName, playerVersionsById)
        if (result) {
            data.push(result)
        }
    }



    if (DEV_MODE) {
        console.log("Done processing event context")
    }
    return data;
}

//
export const apiCalls = {
    simulationData,
    teams,
    games,
    players,
    snapshot,
    snapshots,
    book,
    electionInfo,
    gameEvents,
    electionEvents,
    teamDataForEvents
}